module.exports = __webpack_public_path__ + "static/media/btnPrev.862513de.svg";